var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticStyle:{"display":"block"}},[_vm._v("Version "),_vm._t("default")],2),_c('hr',{staticStyle:{"margin":"16px 0","flex":"1","margin-left":"1em"}})])}
var staticRenderFns = []

export { render, staticRenderFns }